import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../hooks/useFetch';
import { fetchServices } from '../../api/api';
import axios from 'axios';

const Discuss = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        notes: '',
        error: {}
    });
    const [submitting, setSubmitting] = useState(false);
    const { t } = useTranslation();
    const { data: services } = useFetch(["Services"], fetchServices);

    const { name, email, subject, notes, error } = formData;

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
            error: { ...prevState.error, [name]: '' }
        }));
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        let newError = {};

        if (name === '') newError.name = "Please enter your name";
        if (email === '') newError.email = "Please enter your email";
        if (subject === '') newError.subject = "Please enter your subject";
        if (notes === '') newError.notes = "Please enter your note";

        if (Object.keys(newError).length > 0) {
            setFormData((prevState) => ({ ...prevState, error: newError }));
        } else {
            try {
                setSubmitting(true)
                // Extract only the form fields (excluding error)
                const { name, email, subject, notes } = formData;
                const dataToSend = { name, email, subject, notes };

                // Make the POST request with filtered data
                const res = await axios.post(
                    'https://formspree.io/f/xrbgarwv',
                    dataToSend
                );
                console.log(res)
                setSubmitting(false)

                // Reset form data on successful submission
                setFormData({
                    name: '',
                    email: '',
                    subject: '',
                    notes: '',
                    error: {}
                });
            } catch (error) {
                console.error("Error submitting form:", error);
            }
        }
    };

    return (
        <div className="wpo-project-single-item">
            <div className="wpo-project-contact-area">
                <div className="wpo-contact-title">
                    <h2>{t('discuss.title')}</h2>
                    <p>{t('discuss.subtitle')}</p>
                </div>
                <div className="wpo-contact-form-area">
                    <form method="post" onSubmit={submitHandler} className="form">
                        <div className="row">
                            <div className="col col-lg-6 col-md-6 col-12">
                                <div className="form-field">
                                    <input
                                        className="form-control"
                                        value={name}
                                        onChange={changeHandler}
                                        type="text"
                                        name="name"
                                        placeholder={t('discuss.placeholders.name')}

                                    />
                                    <p>{error.name ? error.name : ''}</p>
                                </div>
                            </div>
                            <div className="col col-lg-6 col-md-6 col-12">
                                <div className="form-field">
                                    <input
                                        className="form-control"
                                        onChange={changeHandler}
                                        value={email}
                                        type="email"
                                        name="email"
                                        placeholder={t('discuss.placeholders.email')}
                                    />
                                    <p>{error.email ? error.email : ''}</p>
                                </div>
                            </div>
                            <div className="col col-lg-12 col-12">
                                <div className="form-field">
                                    <select
                                        className="form-control"
                                        onChange={changeHandler}
                                        value={subject}
                                        name="subject"
                                    >
                                        <option disabled value="">
                                            {t('discuss.placeholders.services')}
                                        </option>
                                        {services?.data?.data?.map((service, index) => (
                                            <option key={index} value={service?.data?.title}>
                                                {service?.data?.title}
                                            </option>
                                        ))}
                                    </select>
                                    <p>{error.subject ? error.subject : ''}</p>
                                </div>
                            </div>
                            <div className="fullwidth col col-lg-12 col-12">
                                <textarea
                                    className="form-control"
                                    name="notes"
                                    placeholder={t('discuss.placeholders.notes')}
                                    value={notes}
                                    onChange={changeHandler}
                                ></textarea>
                            </div>
                        </div>
                        <div className="submit-area">
                            <button type="submit" className="theme-btn-s4">  {submitting ? t('submittingButton') : t('discuss.submitButton')}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Discuss;
